// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    ApiKey: "dbManagerProject:23-ab5892-487deb-b41772-134bbf-ed61a3",

    //id plan user institutional assign from admin basic - pro
    idPlanBasicInst: 5, //id store field contents BD - Student
    idPlanProInst: 6, //id store field contents BD - Teacher

    //id product sub PLay Console
    foveaValidator: "https://validator.fovea.cc/v1/validate?appName=com.illunotes.app&apiKey=841dcf6b-3037-48a2-a67b-1d24fe592871",
    basicMonth: 'basic_monthly_sub',
    proMonth: 'pro_monthly_sub',
    basicYear: 'basic_yearly_sub',
    proYear: 'pro_yearly_sub',

    //IDs Planes BD
    basicMonthBD: 1,
    proMonthBD: 2,
    basicYearBD: 3,
    proYearBD: 4,

    ApiUrl: "https://qa.api.illunotes.app/illunotes/api/public/",
    //  verifyRegister: "https://d3tyjj8x1mo9ls.cloudfront.net/register-verify-account?email=",
    verifyRegister: "https://qa.illunotes.app/register-verify-account?email=",
    ApiDateTime: "https://qa.api.illunotes.app/illunotes/api/public/gettimestamp",
    domainOnlyApi: "https://qa.api.illunotes.app/illunotes/api",
    domainOnlyAPP: "https://qa.illunotes.app",
    domainWWWOnlyAPP: "https://qa.illunotes.app",


    WebPushServerPublicKey: "BBTkWcG-DYRTWuLX2Xfo5MOnLjp9lK2jQ0VfrW2sPmLqVjtvbBmIU_8S4pT2dKxlwIqdq9_Wim6Z952SYTgNzUg",
    MAX_PRESENTATION_FILE_SIZE: 6442450944, //6GB
    MAX_MEDIA_FILE_SIZE: 1073741824, //1GB
    INTERVAL_STATUS_TIME: 30000, //30 seconds

    //version illunotes
    versionIlluNotes: "2.2",
    //template and key of SendGrid
    TemplateEmailId: "d-a4b0c2e2a612483fa5abeabe0ec8d4db",
    AuthorizationEmail: "Bearer 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"
};
